import { render, staticRenderFns } from "./OtherLoanStatusTable.vue?vue&type=template&id=9ba7d0e0"
import script from "./OtherLoanStatusTable.vue?vue&type=script&lang=js"
export * from "./OtherLoanStatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports